<template>
<div>
  <v-card>
    <v-card-title class="primary white--text">
      <v-flex xs12 md8>
        Reporte {{ assembly.description }}
      </v-flex>
      <v-flex xs12 md2>
        <v-btn
          medium
          :loading="loading_refresh"
          :disabled="loading_refresh"
          @click="init"
          secondary
        >
          <v-icon left accent>autorenew</v-icon>
          Refrescar
        </v-btn>
      </v-flex>
      <v-flex xs12 md2>
        <v-btn
          medium
          :loading="loading"
          :disabled="loading"
          @click="downloadReport"
          dark
        >
          <v-icon left dark>cloud_download</v-icon>
          Descargar
        </v-btn>
      </v-flex>
    </v-card-title>
    <v-card-text>
      <v-card height="50px" flat>
        <v-bottom-nav
          :active.sync="report_filter"
          :value="true"
          absolute
          color="transparent"
        >
          <v-btn
            color="primary"
            flat
            value="all"
          >
            <span>General</span>
            <v-icon>supervised_user_circle</v-icon>
          </v-btn>

          <v-btn
            color="primary"
            flat
            value="asopaf"
          >
            <span>ASOPAF</span>
            <v-icon>thumb_up</v-icon>
          </v-btn>


        </v-bottom-nav>
      </v-card>
      <v-layout wrap>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'all'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container circle-container"
            height="120"
            width="100"
          >
            <div class="info-title circle"><span>Asistencia</span></div>
            <v-progress-circular
              :rotate="-90"
              :size="75"
              :width="15"
              :value="actualPercent"
              color="teal"
            >
              {{ actualPercent }}%
            </v-progress-circular>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'all'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container circle-container"
            height="160"
            width="100"
          >
            <div class="info-title circle"><span>Q. decisivo</span></div>
            <v-progress-circular
              :rotate="-90"
              :size="75"
              :width="15"
              :value="quorum"
              color="red"
            >
              {{ quorum }}%
            </v-progress-circular>
            <div class="info-data">
              {{ total_assistance_to_quorum }}
            </div>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'all'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container"
            height="160"
            width="100"
          >
            <div class="info-title"><span>T. Familias</span></div>
            <div class="info-data">
              <span>{{ total_families }}</span>
            </div>
            <hr>
            <div class="info-title"><span>H. Familias</span></div>
            <div class="info-data">
              <span>{{ total_active_families }}</span>
            </div>
          </v-sheet>
        </v-flex>

        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'all'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container"
            height="100"
            width="100"
          >
            <div class="info-title"><span>Asistencias</span></div>
            <div class="info-data">
              <span>{{ total_atendance }}</span>
            </div>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'all'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container"
            height="100"
            width="100"
          >
            <div class="info-title"><span>Personales</span></div>
            <div class="info-data">
              <span>{{ assembly.status === 0 ? total_atendance - total_powers : assembly.attendance_families - assembly.attendance_powers }}</span>
            </div>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'all'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container"
            height="100"
            width="100"
          >
            <div class="info-title"><span>Representados</span></div>
            <div class="info-data">
              <span>{{ total_powers }}</span>
            </div>
          </v-sheet>
        </v-flex>

      </v-layout>
      <v-layout wrap>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'all'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container"
            height="100"
            width="100"
          >
            <div class="info-title"><span>Empleados</span></div>
            <div class="info-data">
              <span>{{ total_employee }}</span>
            </div>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'all'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container"
            height="100"
            width="100"
          >
            <div class="info-title"><span>Empl Asist</span></div>
            <div class="info-data">
              <span>{{ total_employee_assistance }}</span>
            </div>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'asopaf'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container circle-container"
            height="120"
            width="100"
          >
            <div class="info-title circle"><span>% ASOPAF</span></div>
            <v-progress-circular
              :rotate="-90"
              :size="75"
              :width="15"
              :value="per_assist_asopaf"
              color="teal"
            >
              {{ per_assist_asopaf }}%
            </v-progress-circular>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'asopaf'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container circle-container"
            height="160"
            width="100"
          >
            <div class="info-title circle"><span>Q. ASOPAF</span></div>
            <v-progress-circular
              :rotate="-90"
              :size="75"
              :width="15"
              :value="quorum_asopaf"
              color="red"
            >
              {{ quorum_asopaf }}%
            </v-progress-circular>

            <div class="info-data">
              {{ total_assistance_to_quorum_asopaf }}
            </div>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'asopaf'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container"
            height="100"
            width="100"
          >
            <div class="info-title"><span>ASOPAF</span></div>
            <div class="info-data">
              <span>{{ total_asopaf }}</span>
            </div>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'asopaf'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container"
            height="100"
            width="100"
          >
            <div class="info-title"><span>ASOPAF Asist</span></div>
            <div class="info-data">
              <span>{{ total_asopaf_assistance }}</span>
            </div>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'asopaf'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container"
            height="100"
            width="100"
          >
            <div class="info-title"><span>ASOPAF Pod</span></div>
            <div class="info-data">
              <span>{{ total_asopaf_power }}</span>
            </div>
          </v-sheet>
        </v-flex>
        <v-flex
          xs12
          md2
          class="card-info"
          v-if="report_filter === 'asopaf'"
        >
          <v-sheet
            :elevation="6"
            class="mx-auto info-container"
            height="100"
            width="100"
          >
            <div class="info-title"><span>ASOPAF Pers</span></div>
            <div class="info-data">
              <span>{{ total_asopaf_personal }}</span>
            </div>
          </v-sheet>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
  <div class="space"></div>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="assists_to_show"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.family_code }} - {{ props.item.family }}</td>
        <td class="text-xs-center">
          <v-icon v-show="props.item.asopaf === 1">
            check_circle
          </v-icon>
        </td>
        <td class="text-xs-center">
          <v-icon v-show="props.item.employee === 1">
            check_circle
          </v-icon>
        </td>
        <td class="text-xs-center">
          <v-icon v-show="props.item.family_sent_agent === 1">
            check_circle
          </v-icon>
        </td>
        <td class="text-xs-center">{{ props.item.powers_number }}</td>
        <td class="text-xs-center">{{ props.item.agent }}</td>
        <td class="text-xs-center">{{ props.item.name }} <br /> {{ props.item.assist_date }}</td>
        <!-- <td class="text-xs-center">
          <v-btn v-if="props.item.physical_signature === 0" color="primary" small @click="seeSignature(props.item.signature_url)">Ver firma</v-btn>
          <span v-else>{{ props.item.notes }}</span>
        </td> -->
      </template>
    </v-data-table>
  </v-card>
  <v-dialog
    v-model="dialog"
    width="500"
  >
  <v-card>
    <v-img
      :src="signature_url"
      aspect-ratio="1"
      class="grey lighten-2"
      contain
      height="250"
    />
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        flat
        @click="dialog = false"
      >
        Cerrar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</div>
</template>

<script>
import axios from 'axios';

export default {
 name: 'assistance-report-view',
 data() {
   return {
     idAssembly : 0,
     search: '',
      headers: [
        { text: 'Familia', align: 'center', value: 'family' },
        { text: 'ASOPAF', align: 'center', value: 'asopaf' },
        { text: 'Empleado', align: 'center', value: 'employee' },
        { text: 'Con poder', align: 'center', value: 'family_sent_agent' },
        { text: '# poderes', align: 'center', value: 'powers_number' },
        { text: 'Representante', align: 'center', value: 'agent', sortable: false },
        { text: 'Fecha y hora registro', align: 'center', value: 'name' },
        // { text: 'Firma', align: 'center', value: 'signature_url', sortable: false }
      ],
      assists: [],
      dialog: false,
      signature_url: "",
      assembly: {},
      actualPercent: 0,
      total_families: 0,
      total_asopaf: 0,
      total_atendance: 0,
      total_powers: 0,
      quorum: 0,
      quorum_asopaf: 0,
      total_asopaf_assistance: 0,
      total_employee: 0,
      total_employee_assistance: 0,
      loading: false,
      total_asopaf_power: 0,
      total_asopaf_personal: 0,
      report_filter: 'all',
      assists_to_show: [],
      total_assistance_to_quorum: 0,
      total_active_families: 0,
      total_assistance_to_quorum_asopaf: 0,
      loading_refresh: false
   }
 },
 created() {
   this.idAssembly = this.$route.params.id;
   this.init()
 },
 computed: {
   per_assist_asopaf() {
     return Math.round(((this.total_asopaf_assistance * 100) / this.total_asopaf) * 100) / 100
   }
 },
 watch: {
   report_filter(newValue, oldValue) {
     this.assists_to_show = this.assists
      .filter(assist => {
        if (newValue === 'all') {
          return true
        }

        if (newValue === 'asopaf') {
          return assist.asopaf === 1
        }

        return false
      })
   }
 },
 methods: {
   init() {
     this.loading_refresh = true
      axios.get(`/api/assembly/report/${this.idAssembly}`)
        .then(response => {
          const { data, status } = response;
          if (status === 200) {
            this.assists = data.assists;
            this.assembly = data.assembly;

            this.actualPercent = this.assembly.status == 0 ? data.actual_percent : this.assembly.attendance_percentage;
            this.total_families = this.assembly.status == 0 ?  data.total_families : this.assembly.assembly_current_families;
            this.total_active_families = this.assembly.status == 0 ?  data.total_active_families : (this.assembly.assembly_current_families - this.assembly.total_families_portfolio_entered);
            this.total_asopaf = this.assembly.status == 0 ?  data.total_asopaf : this.assembly.assembly_current_asopaf_members;
            this.total_asopaf_assistance = this.assembly.status == 0 ?  data.total_asopaf_assistance : this.assembly.attendance_asopaf;
            this.total_atendance = this.assembly.status == 0 ?  data.total_assistance : this.assembly.attendance_families;
            this.total_powers = this.assembly.status == 0 ?  data.total_powers_assistance : this.assembly.attendance_powers;

            this.quorum = data.quorum;

            this.total_employee = this.assembly.status == 0 ?  data.total_employee : this.assembly.assembly_current_families_employee;
            this.total_employee_assistance = this.assembly.status == 0 ?  data.total_employee_assistance : this.assembly.attendance_employees;
            this.total_asopaf_power = this.assembly.status == 0 ?  data.total_asopaf_power : this.assembly.attendance_asopaf_pow;
            this.total_asopaf_personal = this.assembly.status == 0 ?  data.total_asopaf_personal : this.assembly.attendance_asopaf_per;
            this.quorum_asopaf = data.total_asopaf_quorum;
            this.assists_to_show = this.assists
            this.total_assistance_to_quorum = data.total_assistance_to_quorum;
            this.total_assistance_to_quorum_asopaf = data.total_assistance_to_quorum_asopaf
          }
          this.loading_refresh = false
        })
        .catch(error => {
          console.log(error)
          this.loading_refresh = false
        })
   },
   seeSignature(url) {
     this.signature_url = url;
     this.dialog = true;
   },
   downloadReport() {
     this.loading = true;
     axios({
        url: `/download/report/${this.idAssembly}/${this.report_filter}`,
        method: 'GET',
        responseType: 'blob',
      })
      .then(response => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data]));
        link.setAttribute('download', `assembly_${this.idAssembly}_report.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
        this.loading = false;
      });
   }
 }
}
</script>
<style>

.info-container {
  display: flex;
  flex-direction: column;
}

.circle-container {
  padding: 0px 10px 0px 10px;
}

.circle {
  margin-bottom: 3px;
}

.info-title {
  padding: 10px;
  background-color: #fff;
  color: #000;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  border-bottom: 1px solid lightgray;
}

.info-data {
  background-color: #fff;
  color: #000;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  padding-top: 20px;
}

.card-info {
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/report.vue